export const Wrapper = 'flex flex-col pt-6 sm:flex-row'
